<div class="global__sidebar__inner">
  <!-- Search Bar -->
  <search-bar *ngIf="!inTutorial"></search-bar>

  <div class="pt-10px"></div>

  <!-- DeSo Price / Balance -->
  <div
    class="right-bar-creators__balance-box br-12px p-15px mb-30px fs-13px text-grey5 font-weight-bold"
  >
    <div class="d-flex justify-content-between">
      <div>$DESO Price</div>
      <div>
        <span>~{{ globalVars.desoToUSDExchangeRateToDisplay }}</span>
        <span class="text-grey5">&nbsp;USD per coin</span>
      </div>
    </div>
    <div
      *ngIf="globalVars.loggedInUser"
      class="d-flex justify-content-between pt-10px"
    >
      <div class="d-flex" style="min-width: 150px">Your $DESO</div>
      <div
        class="d-flex flex-column justify-content-end flex-wrap"
        style="align-items: flex-end"
      >
        <div>
          <!-- Amount in DeSo-->
          {{ globalVars.nanosToDeSo(globalVars.loggedInUser.BalanceNanos) }}
        </div>

        <div class="d-flex text-grey5">
          <!-- Amount in USD-->
          <div class="ml-10px mr-10px">≈</div>
          <div *ngIf="globalVars.satoshisPerDeSoExchangeRate">
            <span>
              {{
                globalVars.nanosToUSD(globalVars.loggedInUser.BalanceNanos, 2)
              }}
              USD
            </span>
          </div>
          <div *ngIf="!globalVars.satoshisPerDeSoExchangeRate">
            Fetching... USD
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-between pt-10px"
      *ngIf="globalVars.transactionFeeMax > 0"
    >
      <div>Node fee per tx:</div>
      <div>
        {{ globalVars.nanosToUSD(globalVars.transactionFeeMax, 4) }} Max
        <span
          (click)="tooltip.toggle()"
          class="ml-1 mb-1 cursor-pointer text-primary"
          matTooltipClass="global__mat-tooltip global__mat-tooltip-font-size"
          [matTooltip]="globalVars.transactionFeeInfo"
          #tooltip="matTooltip"
        >
          <i class="fas fa-info-circle fa-md align-middle"></i>
        </span>
      </div>
    </div>
  </div>

  <div
    *ngIf="
      globalVars.loggedInUser &&
      !globalVars.loggedInUser.EmailVerified &&
      !inTutorial
    "
    class="bg-light br-12px p-15px mb-30px fs-13px"
  >
    <p>Your email is not verified.</p>
    <div *ngIf="globalVars.loggedInUser.HasEmail">
      <a
        class="font-weight-bold"
        (click)="globalVars.resendVerifyEmail()"
        *ngIf="!globalVars.resentVerifyEmail"
        >Resend Verification Email</a
      >
      <p *ngIf="globalVars.resentVerifyEmail">Sent!</p>
    </div>
    <a
      *ngIf="!globalVars.loggedInUser.HasEmail"
      [routerLink]="'/' + globalVars.RouteNames.SETTINGS"
      class="font-weight-bold"
      >Update your email</a
    >
  </div>

  <!-- Sign Up Flow -->
  <div *ngIf="globalVars.loggedInUser == null" class="mb-30px">
    <right-bar-signup></right-bar-signup>
  </div>

  <!-- Title -->
  <div
    class="fs-15px text-grey5 font-weight-bold mb-10px d-flex flex-column"
    [ngClass]="{ 'pb-10px': !activeRightTabOption.poweredBy }"
    *ngIf="!inTutorial"
  >
    <div>
      <select
        #rightBarSelect
        id="right-bar-chart-select"
        class="right-bar-select-box fs-15px text-grey5 font-weight-bold cursor-pointer"
        [ngStyle]="{ width: selectedOptionWidth }"
        (change)="selectTab()"
        [(ngModel)]="activeTab"
      >
        <option
          *ngFor="let option of RightBarCreatorsComponent.chartMap | keyvalue"
          [value]="option.key"
          class="fs-15px text-grey5 font-weight-bold"
        >
          {{ option.key }}
        </option>
      </select>
    </div>
    <div class="pt-5px" *ngIf="activeRightTabOption.poweredBy">
      <a
        class="link--unstyled fs-12px text-grey7"
        [href]="activeRightTabOption.poweredBy.link"
        target="_blank"
      >
        <i class="fas fa-external-link-alt pr-5px"></i>
        Powered by {{ activeRightTabOption.poweredBy.name }}
      </a>
    </div>
  </div>

  <!-- Creators -->
  <right-bar-creators-leaderboard
    [activeTab]="activeTab"
    *ngIf="!inTutorial"
  ></right-bar-creators-leaderboard>
</div>
